import { render, staticRenderFns } from "./CatalogFormEdit.vue?vue&type=template&id=3db0ee1f&scoped=true"
import script from "./CatalogFormEdit.vue?vue&type=script&lang=js"
export * from "./CatalogFormEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db0ee1f",
  null
  
)

export default component.exports